import { AnyWorkRemaining } from './components/AnyWorkRemaining';
import { RemainingWorkDescription } from './components/RemainingWorkDescription';
import { ShowIf } from '../../../../components/ShowIf';
import { usePropertyWorkNeeded } from '../../../../../queries/PropertyFields/BridgeFields';

interface AnyWorkToBeCompletedProps {
    propertyGuid: string;
    isReview?: boolean;
}

export const AnyWorkToBeCompleted: React.FC<AnyWorkToBeCompletedProps> = ({ propertyGuid, isReview = false }) => {
    const [workNeeded] = usePropertyWorkNeeded(propertyGuid);

    return (
        <>
            <AnyWorkRemaining
                propertyGuid={propertyGuid}
                required={true}
                isReview={isReview}
            />
            <ShowIf showIf={workNeeded}>
                <RemainingWorkDescription
                    propertyGuid={propertyGuid}
                    required={true}
                    isReview={isReview}
                />
            </ShowIf>
        </>
    );
};
